import { render, staticRenderFns } from "./video_4.vue?vue&type=template&id=05fb2956&scoped=true&"
var script = {}
import style0 from "./video_4.vue?vue&type=style&index=0&id=05fb2956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb2956",
  null
  
)

export default component.exports